export const CONVERSATIONS = 'CONVERSATIONS';

export const CONTENTS = 'CONTENTS';
